import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, map, tap } from 'rxjs';
import { LoginService } from 'src/app/accountancy/authentication/login/login-service/login.service';
import { ApiRoutes } from 'src/app/accountancy/utilities/classes/api-routes.class';
import { DisbursedInterface } from 'src/app/accountancy/utilities/interfaces/disbursed.interface';
import { ApiGetResponse, DisbursementVoucherIntertace } from 'src/app/accountancy/utilities/interfaces/global.interface';
import { HttpApiService } from 'src/app/accountancy/utilities/services/http-api/http-api.service';

@Injectable({
  providedIn: 'root'
})
export class DisbursedService {

  private readonly _type$ = new BehaviorSubject<"Reimbursement" | "Cash Advance" | "Liquidation" | undefined>(undefined);
  private readonly _controlNUmber$ = new BehaviorSubject<string | undefined>(undefined);
  private readonly _currVoucher$ = new BehaviorSubject<DisbursementVoucherIntertace | undefined>(undefined);

  constructor(
    private _api: HttpApiService,
    private _loginS: LoginService,
  ) { }

  public readonly voucher = {
    setCurrValue: ({ disbursementVoucher, controlNumber, type }: ViewVoucher) => {
      this._currVoucher$.next(disbursementVoucher);
      this._controlNUmber$.next(controlNumber);
      this._type$.next(type);
    },
    getCurrValue: () => combineLatest([
      this._currVoucher$,
      this._controlNUmber$,
      this._type$,
    ]).pipe(map(([currVoucher, controlNumber, type]) => ({ currVoucher, controlNumber, type }))),
  }

  public getDisbursedList(start?: number | null, limit?: number | null, query?: string | null, by?: number | null, approver?: number | null) {
    return this._api.sendGetRequest<HttpResponse<ApiGetResponse<DisbursedInterface>>>(
      `${ApiRoutes.disbursed}?${start != undefined ? 'Start=' + start : ''}${limit ? '&Limit=' + limit : ''}${query ? '&Search=' + query : ''}${by ? '&RequestedBy=' + by : ''}${approver ? '&Approver=' + approver : ''}`,
      this._loginS.getTokenHeader
    )
  }
}

interface ViewVoucher {
  disbursementVoucher?: DisbursementVoucherIntertace;
  controlNumber?: string;
  type?: "Reimbursement" | "Cash Advance" | "Liquidation";
}